<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import CustomerFieldErrorMessageMixin from './mixins/customer_field_error_message';

export default {
  mixins: [CustomerFieldErrorMessageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
  },

  computed: {
    ...mapState({
      input(state) {
        return state.inputs[this.name];
      },
      error(state) {
        return state.inputs[this.name].error;
      }
    }),

    value: {
      get() {
        return this.input.value;
      },

      set(value) {
        this.setValue({
          name: this.name,
          value
        });

        this.validateField(this.name);
      }
    },

    checkboxClass() {
      return {
        'c-form__checkbox': true,
        'c-form__checkbox--error': this.error
      };
    },

    labelFor() {
      return `payment_page_${this.name}`;
    },
  },

  methods: {
    ...mapActions([
      'validateField'
    ]),

    ...mapMutations({
      setValue: 'setInputValue'
    }),
  }
};
</script>

<template>
  <div :class="checkboxClass">
    <input
      :id="labelFor"
      v-model="value"
      :name="input.name"
      value="on"
      type="checkbox"
    >

    <div class="c-form__checkbox__checkmark" />

    <label
      :for="labelFor"
      class="ps-4"
    >
      <slot />
    </label>

    <div class="c-form__feedback">
      {{ errorMessage }}
    </div>
  </div>
</template>
